import React from 'react';

import Money from '@components/Gui/Money';

/**
 * ReceivableBalances
 *
 * Display balance boxes for receivable statements
 * Shows what clients owe to the agency
 */
const ReceivableBalances = ({ totalBalances, availableBalances }) => {
    return (
        <>
            {totalBalances && Object.keys(totalBalances).length > 0 && (
                <div className="statement-balance-box">
                    <small>total balance</small>
                    <div className="statement-balance-box-amounts">
                        {Object.entries(totalBalances).map(([currency, amount]) => (
                            <Money key={currency} currency={currency} amount={amount} />
                        ))}
                    </div>
                </div>
            )}
            {availableBalances && Object.keys(availableBalances).length > 0 && (
                <div className="statement-balance-box">
                    <small>available balance</small>
                    <div className="statement-balance-box-amounts">
                        {Object.entries(availableBalances).map(([currency, amount]) => (
                            <Money key={currency} currency={currency} amount={amount} />
                        ))}
                    </div>
                </div>
            )}
        </>
    );
};

export default ReceivableBalances;

